<template>
  <div>
    <v-card elevation="0" class="px-5">
      <v-card-text width="100%">
        <div class="">
          <template>
            <v-tabs class="tabs-pill" v-model="tab">
              <v-tab href="#subscription" class="text-capitalize"
                >Subscription</v-tab
              >
              <v-tab-item value="subscription">
                <!-- <h2>Subscription</h2> -->
                <div class="mt-6">
                  <div v-if="screen === 1">
                    <v-alert outlined text prominent color="#FFB443">
                      Membership Plans
                    </v-alert>
                    <v-row>
                      <v-col>
                        <b
                          >Current membership plan:
                          {{
                            activeMembershipPlan &&
                            activeMembershipPlan.membershipData.membership_name
                          }}
                          (Valid Up to
                          {{
                            activeMembershipPlan &&
                            formatDate(activeMembershipPlan.end_date)
                          }})</b
                        >
                      </v-col>
                      <v-col>
                        <div class="float-right">
                          <v-btn depressed color="primary" @click="screen = 4">
                            VIEW ALL ADD-ONS
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        v-for="(item, index) in membershipPlansToDisplay"
                        :key="index"
                        cols="6"
                      >
                        <v-card
                          elevation="2"
                          :style="{
                            border: item.id == 1 ? '2px solid #14c27e' : '',
                          }"
                        >
                          <v-card-text class="mb-12">
                            <v-card-title
                              class="font-weight-bold black-text justify-center"
                            >
                              {{ item.membership_name }}
                            </v-card-title>
                            <v-card-subtitle class="text-center">
                              {{
                                item.membershipFeesData.is_free_trial
                                  ? `${item.membershipFeesData.free_trial_period_in_days}-day free trial`
                                  : `$${item.membershipFeesData.per_month_fee} per month`
                              }}
                            </v-card-subtitle>
                            <v-row
                              class="mb-1"
                              style="min-height: 85px"
                              v-if="
                                Number(item.id) ===
                                (activeMembershipPlan &&
                                  activeMembershipPlan.membership_id)
                              "
                            >
                              <v-col>
                                <p style="font-size: 12px">
                                  {{
                                    `Valid up to ${
                                      activeMembershipPlan &&
                                      formatDate(activeMembershipPlan.end_date)
                                    }`
                                  }}
                                </p>
                              </v-col>
                              <v-col>
                                <div
                                  class="float-right"
                                  v-if="
                                    Number(item.id) ===
                                    (activeMembershipPlan &&
                                      activeMembershipPlan.membership_id)
                                  "
                                >
                                  <a
                                    v-on:click="getSubs()"
                                    href="#"
                                    style="font-size: 12px"
                                    >Renew Validity</a
                                  >
                                </div>
                              </v-col>
                            </v-row>
                            <div
                              class="text-center mb-1"
                              style="min-height: 85px"
                              v-else
                            >
                              <v-btn
                                depressed
                                color="primary"
                                @click="selectPlanToBuy(item)"
                              >
                                Buy Now
                              </v-btn>
                            </div>
                            <v-divider></v-divider>
                            <div style="margin-left: -15px">
                              <v-list dense>
                                <v-list-item>
                                  <v-list-item-icon>
                                    <span class="material-icons">done</span>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Package of
                                      {{ item.satellite_report }} satellite
                                      reports
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-icon>
                                    <span class="material-icons">done</span>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      {{ item.pasture_report }} pasture reports
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-icon>
                                    <span class="material-icons">done</span>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Up to {{ item.no_of_animals }} animals
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <div v-if="JSON.parse(item.other_config)">
                                  <v-list-item
                                    v-for="(list, i) in JSON.parse(
                                      item.other_config
                                    )"
                                    :key="i"
                                  >
                                    <v-list-item-icon>
                                      <span class="material-icons">done</span>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-text="list.item"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                              </v-list>

                              <v-card-text>
                                {{ item.description }}
                              </v-card-text>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-if="screen === 2">
                    <v-row class="mb-1">
                      <v-col>
                        <b class="text-h5">Upgrade membership plan</b>
                      </v-col>
                      <v-col>
                        <div class="float-right">
                          <v-btn
                            dense
                            outlined
                            color="green"
                            @click="screen = 1"
                            class="mr-4"
                          >
                            Back
                          </v-btn>
                          <v-btn depressed color="primary" @click="screen = 4">
                            VIEW ALL ADD-ONS
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <v-alert outlined text prominent color="#FFB443">
                      Your Chosen Membership Plan
                    </v-alert>
                    <v-row>
                      <v-col cols="6">
                        <v-card elevation="2" outlined>
                          <v-card-text class="mb-12">
                            <v-card-title
                              class="font-weight-bold black-text justify-center"
                            >
                              {{ selectedPlan.membership_name }}
                            </v-card-title>
                            <v-card-subtitle class="text-center">
                              {{
                                selectedPlan.membershipFeesData.is_free_trial
                                  ? `${selectedPlan.membershipFeesData.free_trial_period_in_days}-day free trial`
                                  : `$${selectedPlan.membershipFeesData.per_month_fee} per month`
                              }}
                            </v-card-subtitle>
                            <v-divider></v-divider>
                            <div style="margin-left: -15px">
                              <v-list dense>
                                <v-list-item>
                                  <v-list-item-icon>
                                    <span class="material-icons">done</span>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Package of
                                      {{ selectedPlan.satellite_report }}
                                      satellite reports
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-icon>
                                    <span class="material-icons">done</span>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      {{ selectedPlan.pasture_report }} pasture
                                      reports
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-icon>
                                    <span class="material-icons">done</span>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Up to
                                      {{ selectedPlan.no_of_animals }} animals
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <div
                                  v-if="JSON.parse(selectedPlan.other_config)"
                                >
                                  <v-list-item
                                    v-for="(list, i) in JSON.parse(
                                      selectedPlan.other_config
                                    )"
                                    :key="i"
                                  >
                                    <v-list-item-icon>
                                      <span class="material-icons">done</span>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-text="list.item"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                              </v-list>

                              <v-card-text>
                                {{ selectedPlan.description }}
                              </v-card-text>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-alert
                      outlined
                      text
                      prominent
                      color="#FFB443"
                      class="mt-4"
                    >
                      Your can choose optional Add-ons
                    </v-alert>
                    <v-row class="mb-4">
                      <v-col
                        cols="4"
                        v-for="(addon, idx) in getAllAddons.slice(0, 3)"
                        :key="idx"
                      >
                        <v-card outlined>
                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-checkbox
                                  v-model="selectedAddons"
                                  :label="addon.name"
                                  :value="addon"
                                  class="ml-2"
                                ></v-checkbox>
                              </v-list-item-title>
                              <v-row>
                                <v-col class="addon-prices">
                                  ${{ addon.per_month_fee }} Per Month
                                </v-col>
                                <v-col class="addon-prices">
                                  ${{ addon.per_year_fee }} Per Year
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item
                            class="addon-name"
                            v-for="(ad, i) in addon.addon_details"
                            :key="i"
                          >
                            {{ ad.addon_type }}
                          </v-list-item>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions class="mt-3 float-right">
                      <v-btn dense outlined color="green" @click="screen = 1">
                        Back
                      </v-btn>
                      <v-btn depressed color="primary" @click="screen = 3">
                        Continue
                      </v-btn>
                    </v-card-actions>
                  </div>
                  <div v-if="screen === 3">
                    <v-alert outlined text prominent color="#FFB443">
                      Membership Plans
                    </v-alert>
                    <v-card elevation="2" outlined class="mb-5">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <v-card-title class="font-weight-bold">
                              {{ selectedPlan.membership_name }}
                            </v-card-title>
                            <v-card-subtitle
                              >${{
                                selectedPlan.membershipFeesData.per_month_fee
                              }}
                              per month</v-card-subtitle
                            >
                          </v-col>
                          <v-col>
                            <div class="text-center mt-5 float-right">
                              <v-btn
                                depressed
                                color="primary"
                                @click="changePlan"
                              >
                                Change Plan
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <div v-if="selectedAddons.length > 0">
                          <b class="text-h6 ma-4">Your Selected Add-Ons</b>
                          <v-row class="py-4 px-8 mx-4 addons-container">
                            <v-list-item
                              v-for="(addOns, index) in selectedAddons"
                              :key="index"
                              style="border-bottom: 1px solid #efefef"
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                  style="font-size: 14px; font-weight: 600"
                                >
                                  {{ addOns.name }}
                                </v-list-item-title>

                                <v-list-item-subtitle>
                                  ${{ addOns.per_month_fee }} per month
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-icon @click="removeAddon(addOns.id)">
                                  mdi-close
                                </v-icon>
                              </v-list-item-action>
                            </v-list-item>
                            <v-btn
                              depressed
                              color="primary"
                              @click="screen = 4"
                              class="mt-4"
                            >
                              Add Another Add-On
                            </v-btn>
                          </v-row>
                        </div>
                        <v-row>
                          <v-col>
                            <v-card-text>{{
                              selectedPlan.membership_name
                            }}</v-card-text>
                          </v-col>
                          <v-col>
                            <div class="float-right">
                              <v-card-text
                                >${{
                                  selectedPlan.membershipFeesData.per_month_fee
                                }}</v-card-text
                              >
                            </div>
                          </v-col>
                        </v-row>
                        <v-row v-if="selectedAddons.length > 0">
                          <v-col>
                            <v-card-text>Add-on</v-card-text>
                          </v-col>
                          <v-col>
                            <div class="float-right">
                              <v-card-text>${{ addonsFee }}</v-card-text>
                            </div>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <div class="mt-6">
                          <v-row>
                            <v-col>
                              <v-card-title class="font-weight-bold"
                                >Total Price
                              </v-card-title>
                            </v-col>
                            <v-col>
                              <div class="float-right">
                                <v-card-title class="font-weight-bold"
                                  >${{ totalPrice }}
                                </v-card-title>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-divider></v-divider>
                    <v-card-actions class="mt-3 float-right">
                      <v-btn
                        dense
                        outlined
                        color="green"
                        @click="screen = 1"
                        class="mr-4"
                      >
                        Back
                      </v-btn>
                      <PayPal
                        :amount="totalPrice.toString()"
                        currency="USD"
                        :client="credentials"
                        env="sandbox"
                        @payment-authorized="paymentAuthorized"
                        @payment-completed="paymentCompleted"
                        @payment-cancelled="paymentCancelled"
                      >
                      </PayPal>
                    </v-card-actions>
                  </div>
                  <div v-if="screen === 4">
                    <v-row class="mb-1">
                      <v-col>
                        <b class="text-h5">Available Add-Ons</b>
                      </v-col>
                      <v-col>
                        <div class="float-right">
                          <v-btn
                            dense
                            outlined
                            color="green"
                            @click="screen = 1"
                            class="mr-4"
                          >
                            Back
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="4"
                        v-for="(addon, idx) in getAllAddons"
                        :key="idx"
                      >
                        <v-card outlined>
                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-checkbox
                                  v-model="selectedAddons"
                                  :label="addon.name"
                                  :value="addon"
                                  class="ml-2"
                                ></v-checkbox>
                              </v-list-item-title>
                              <v-row>
                                <v-col class="addon-prices">
                                  ${{ addon.per_month_fee }} Per Month
                                </v-col>
                                <v-col class="addon-prices">
                                  ${{ addon.per_year_fee }} Per Year
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item
                            class="addon-name"
                            v-for="(ad, i) in addon.addon_details"
                            :key="i"
                          >
                            {{ ad.addon_type }}
                          </v-list-item>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-btn
                      depressed
                      color="primary"
                      @click="screen = 3"
                      class="mt-4"
                      v-if="Object.keys(selectedPlan).length > 0"
                    >
                      Continue
                    </v-btn>
                  </div>

                  <v-snackbar v-model="snackbar" timeout="6000" color="primary">
                    {{ snackbarMessage }}
                  </v-snackbar>
                </div>
              </v-tab-item>

              <!-- <v-tab href="#payment" class="text-capitalize">Payment Method</v-tab> -->
              <!-- <v-tab-item value="payment">
                <div v-if="Payscreen == 0" class=" text-center">
                  <v-card flat>
                    <div class="text-center">
                      <v-row justify="center" align="center">
                        <v-col>
                          <div style="margin-top: 50px" class="py-16">
                            <img src="/img/dots.png" /><br />
                            <h1 class="pt-10">No Payment Method Found</h1><br />
                            <div>
                              <h3 style="color: #787878">Manage Your Payment Method</h3>
                            </div>
                            <v-btn class="mt-6" width=200 small color="primary" dark @click="getPaymentS3()">
                              ADD A PAYMENT METHOD
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </div>
                <div v-if="Payscreen==4">
                  <v-form>
                    <v-container style="max-width: 400px; margin-top: 100px;">
                      <div align="center" class="mb-10"><img src="/img/logos_paypal.png" /></div>
                      <br />
                      <v-card v-if="access == 1" outlined rounded width="400" height="60" class="newD mb-4">
                        <div class="material-icons" style="color:red;">
                          report_problem
                        </div>
                        <div style="color: black; font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;Some
                          of your info isn't correct. Please try again.</div>
                      </v-card>
                      <v-row>
                        <v-col>
                          <v-text-field flat solo v-model=email placeholder="Email or Phone Number" :rules="rules.email">
                            <template slot="prepend">
                              <svg style="width:30px;height:30px" viewBox="0 0 24 24" class="px-1">
                                  <path fill="currentColor" d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z" />
                              </svg> 
                              <div style="border-left: 1px solid #000000; height: 30px;"></div>
                              <svg style="width:30px;height:30px" viewBox="0 0 24 24" class="px-1">
                                  <path fill="currentColor" d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
                              </svg>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col style="">
                          <v-text-field v-model=password :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show2 ? 'text' : 'password'" flat solo placeholder="Password*"
                            prepend-inner-icon="mdi-lock-outline" :rules="rules.password"
                            @click:append="show2 = !show2">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-btn block color="primary" height="50" class="mt-15" @click="getPaymentS5()">LOGIN</v-btn>
                    </v-container>
                  </v-form>
                </div>
                <div v-if="Payscreen==5">
                  <div class="mt-6">
                    <v-alert outlined text prominent color="#FFB443">
                      <span style="color: black" class="font-weight-bold">Your Current Payment
                        Method</span>
                    </v-alert>
                    <v-card elevation="3" class="mx-auto" height="600" outlined>
                      <h3 class="pt-10 pb-4 pl-4"> PAYPAL</h3>
                      <v-divider></v-divider>
                      <v-card elevation="2" class="mx-auto mt-10" max-width="300" outlined>
                        <v-row>
                          <v-col>
                            <div class="mb-2 mt-12 ml-6"> <img height="70" width="50" src="/img/logos_paypal.png" />
                            </div><br />
                          </v-col>
                          <v-col>
                            <v-card-text class="font-weight-bold mb-10 mt-14 mr-4">
                              Idiadroa@gmail.com</v-card-text>
                          </v-col>
                        </v-row>
                      </v-card>
                      <v-card-actions style="margin-top: 250px" class="float-right">
                        <v-btn dense outlined color="green" @click="getPaymentS4()">
                          USE ANOTHER PAYPAL
                        </v-btn>
                        <v-btn depressed color="primary" @click="getPaymentS6()">
                          USE THIS PAYPAL
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </div>
                </div>
                <div v-if="Payscreen==6">
                  <div class="mt-6">
                    <h2> CONFIRMATION</h2>
                    <v-card elevation="3" class="mx-auto mt-4" height="500" outlined>
                      <h3 class="pt-10 pb-4 pl-4">Amount</h3>
                      <h1 class="ml-16 mb-16 mt-16"> $500 </h1>
                      <v-divider></v-divider>
                      <h3 class="pt-10 pb-4 pl-4"> Method</h3>
                      <v-card elevation="2" class="ml-8 mt-10" max-width="300" height="120" outlined>
                        <v-row>
                          <v-col>
                            <div class="mb-2 mt-6 ml-6"> <img height="70" width="50" src="/img/logos_paypal.png" />
                            </div><br />
                          </v-col>
                          <v-col>
                            <v-card-text class="font-weight-bold mb-4 mt-8">
                              Idiadroa@gmail.com</v-card-text>
                          </v-col>
                        </v-row>
                      </v-card>
                      <v-card-actions class="float-right">
                        <v-btn style="margin-top: 100px" depressed color="primary" @click="getPaymentS7()">
                          CONFIRM
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </div>
                </div>
              </v-tab-item> -->
              <v-dialog
                v-if="Payscreen == 3"
                v-model="dialog"
                width="400"
                @click:outside="closeModal()"
              >
                <v-card class="custom-card" rounded="0">
                  <v-toolbar color="secondary" class="white--text">
                    <v-toolbar-title class="font-weight-bold">
                      Payment Method
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon class="white--text" @click="closeModal()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-form ref="addUser" lazy-validation autocomplete="off">
                    <v-card-text class="black--text mt-10">
                      <v-row>
                        <v-col cols="12">
                          <h2>Adding A Payment Method</h2>
                          <v-card class="mt-10" height="100">
                            <v-row>
                              <v-col class="ml-15" style="flex-grow: 0">
                                <img
                                  width="50"
                                  height="70"
                                  src="/img/logos_paypal.png"
                                /><br />
                              </v-col>
                              <v-col style="flex-grow: 0">
                                <h1 class="text-center pt-6 pr-10">Paypal</h1>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-card-actions
                        class="mt-10 mb-10"
                        style="padding-right: 0"
                      >
                        <v-spacer></v-spacer>
                        <v-row align="center">
                          <v-btn
                            height="44"
                            width="156"
                            color="primary"
                            @click="getPaymentS4()"
                          >
                            Next
                          </v-btn>
                        </v-row>
                      </v-card-actions>
                    </v-card-text>
                  </v-form>
                </v-card>
              </v-dialog>
              <v-dialog
                v-if="Payscreen == 7"
                v-model="dialog1"
                width="600"
                @click:outside="closeModal1()"
              >
                <v-card class="custom-card" rounded="0">
                  <v-toolbar color="secondary" class="white--text">
                    <v-toolbar-title class="font-weight-bold">
                      Congratulations
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon class="white--text" @click="closeModal1()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-form ref="addUser" lazy-validation autocomplete="off">
                    <v-card-text class="black--text mt-10">
                      <v-row>
                        <v-col cols="12">
                          <div align="center">
                            <img
                              width="130"
                              height="100"
                              src="/img/Frame.png"
                            />
                          </div>
                          <br />
                          <h2 style="color: #117443" align="center">
                            Your Payment was <br />
                            Successful!
                          </h2>
                          <h4 class="text-center pt-8">
                            We have emailed a copy of your <br />
                            recipt to example@email.com
                          </h4>
                        </v-col>
                      </v-row>
                      <v-card-actions class="mt-10">
                        <v-spacer></v-spacer>
                        <v-btn
                          style="float: right"
                          height="44"
                          color="primary"
                          @click="closeModal()"
                        >
                          DONE
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-tabs>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
import generalMixin from "@/mixins/GeneralMixin";
import PayPal from "vue-paypal-checkout";
import moment from "moment";

export default {
  name: "Subscription",
  components: {
    PayPal,
  },
  data() {
    return {
      screen: 1,
      Payscreen: 0,
      dialog: false,
      dialog1: false,
      email: "",
      password: "",
      access: 0,
      show2: true,
      tab: "",
      rules: {
        email: [(v) => !!v || "Email or Phone Number is required"],
        password: [(v) => !!v || "password is required"],
      },
      credentials: {
        sandbox:
          "AQg0_sStegJDdn4y7X3F3SO8QpQBtegCld3pp42TbEIFnRLfmdM_DtCONxLQuXvviulx0k8kLdRf4m75",
        production: "",
      },
      customPaypalButton: {
        label: "checkout",
        size: "large",
        shape: "pill",
        color: "blue",
      },
      selectedPlan: {},
      selectedAddons: [],
      loaded: false,
      snackbar: false,
      snackbarMessage: "",
    };
  },
  mixins: [loadingMixin, generalMixin],
  computed: {
    activeMembershipPlan() {
      if (this.getUserMembershipPlan && this.getUserMembershipPlan.length > 0) {
        return this.getUserMembershipPlan.filter((item) => item.active)[0];
      }
      return null;
    },
    addonsFee() {
      return this.selectedAddons.reduce((prev, next) => {
        return prev + next.per_month_fee;
      }, 0);
    },
    totalPrice() {
      if (this.addonsFee) {
        return (
          this.addonsFee + this.selectedPlan.membershipFeesData.per_month_fee
        );
      } else {
        return null;
      }
    },
    membershipPlansToDisplay() {
      if (this.getAllmembershipPlans) {
        if (
          this.activeMembershipPlan &&
          this.activeMembershipPlan.membership_id !== 1
        ) {
          return this.getAllmembershipPlans.filter((item) => item.id != 1);
        } else {
          return this.getAllmembershipPlans;
        }
      }
      return null;
    },
  },
  mounted() {
    this.$apollo.queries.getAllmembershipPlans.refetch();
    this.$apollo.queries.getUserMembershipPlan.refetch();

    console.log("testing");
    // const script = document.createElement('script')
    // script.src = 'https://www.paypal.com/sdk/js?client-id=AQg0_sStegJDdn4y7X3F3SO8QpQBtegCld3pp42TbEIFnRLfmdM_DtCONxLQuXvviulx0k8kLdRf4m75'
    // document.body.appendChild(script);
  },
  methods: {
    getSubs() {
      this.screen = 2;
    },
    getPaymentS3() {
      this.Payscreen = 3;
      this.dialog = true;
    },
    getPaymentS4() {
      this.Payscreen = 4;
      this.dialog = false;
    },
    getPaymentS5() {
      if (this.email == "abc@gmail.com" && this.password == "12345") {
        this.Payscreen = 5;
        this.access = 0;
      } else {
        this.access = 1;
      }
    },
    getPaymentS6() {
      this.Payscreen = 6;
    },
    getPaymentS7() {
      this.Payscreen = 7;
      this.dialog1 = true;
    },
    closeModal() {
      this.dialog = 0;
      this.dialog1 = 0;
      this.Payscreen = 0;
    },
    closeModal1() {
      this.dialog = 0;
      this.dialog1 = 0;
      this.Payscreen = 6;
    },
    setLoaded() {
      this.loaded = true;
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  description: this.product.description,
                  amount: {
                    currency_code: "USD",
                    value: this.product.price,
                  },
                },
              ],
            });
          },
          onApprove: async (data, actions) => {
            const order = await actions.order.capture();
            this.paidFor = true;
            console.log(order);
          },
          onError: (err) => {
            console.log(err);
          },
        })
        .render(this.$refs.paypal);
    },
    selectPlanToBuy(item) {
      this.screen = 2;
      this.selectedPlan = item;
    },
    changePlan() {
      this.screen = 1;
      this.selectedPlan = [];
      this.selectedAddons = [];
    },
    removeAddon(id) {
      this.selectedAddons = this.selectedAddons.filter(
        (item) => item.id !== id
      );
    },
    paymentAuthorized() {
      this.snackbarMessage = "Payment authorized successfully.";
      this.snackbar = true;
    },
    async createUserMembership(paymentId) {
      const startDate = moment().format("YYYY-MM-DD");
      const endDate = moment(startDate).add(1, "M");
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: CreateUserMembershipInput!) {
              createUserMembership(createUserMembershipInput: $data) {
                id
              }
            }
          `,
          // Parameters
          variables: {
            data: {
              membershipId: Number(this.selectedPlan.id),
              paymentId: Number(paymentId),
              startDate,
              endDate,
            },
          },
        })
        .then(async (res) => {
          if (
            res.data.createUserMembership &&
            res.data.createUserMembership.id
          ) {
            await this.createUserAddons(res.data.createUserMembership.id);
          }
        })
        .catch(async (error) => {
          console.log(error);
          this.stopLoading();
        });
    },
    async createUserAddons(userMemershipId) {
      const startDate = moment().format("YYYY-MM-DD");
      const endDate = moment(startDate).add(1, "M");
      const addonIds = this.selectedAddons.map((item) => Number(item.id));
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: CreateUserAddonsInput!) {
              createUserAddons(createUserAddonsInput: $data) {
                id
              }
            }
          `,
          // Parameters
          variables: {
            data: {
              addonIds,
              userMembershipId: Number(userMemershipId),
              startDate,
              endDate,
            },
          },
        })
        .then(async (res) => {
          if (res.data.createUserAddons) {
            this.$apollo.queries.getUserMembershipPlan.refetch();
            this.stopLoading();
          }
          await this.changePlan();
        })
        .catch(async (error) => {
          console.log(error);
          this.stopLoading();
        });
    },
    async paymentCompleted(response) {
      if (response.state === "approved") {
        this.startLoading();
        this.$apollo
          .mutate({
            // Query
            mutation: gql`
              mutation ($data: CreatePaymentInput!) {
                createPayment(createPaymentInput: $data) {
                  id
                }
              }
            `,
            // Parameters
            variables: {
              data: {
                paymentMethod: 1,
                transactionId: response.id,
                status: response.state,
                amount: this.totalPrice,
                currency: response.transactions[0].amount.currency,
                paymentNote: response.cart,
                paymentDate: this.formatDate(response.create_time),
                isRefund: false,
                payerInfo: JSON.stringify(response.payer.payer_info),
                // payerInfo: 'testing'
              },
            },
          })
          .then(async (res) => {
            if (res.data.createPayment && res.data.createPayment.id) {
              console.log("payment successfull");
              await this.createUserMembership(res.data.createPayment.id);
              this.snackbarMessage = "Payment successful. Plan upgraded.";
              this.snackbar = true;
            }
          })
          .catch(async (error) => {
            console.log(error);
            this.stopLoading();
          });
      }
    },
    paymentCancelled() {
      this.snackbarMessage = "Payment cancelled. Please try again.";
      this.snackbar = true;
    },
  },
  apollo: {
    getAllmembershipPlans: gql`
      query {
        getAllmembershipPlans {
          id
          membership_name
          description
          no_of_animals
          satellite_report
          pasture_report
          other_report
          plan_duration
          plan_duration_unit
          other_config
          organization
          membershipFeesData {
            id
            per_month_fee
            per_year_fee
            is_free_trial
            free_trial_period_in_days
            default_status
          }
        }
      }
    `,
    getUserMembershipPlan: gql`
      query {
        getUserMembershipPlan {
          id
          membership_id
          start_date
          end_date
          active
          membershipData {
            membership_name
            description
            no_of_animals
            satellite_report
            pasture_report
            other_report
            plan_duration
            plan_duration_unit
            other_config
            organization
            membershipFeesData {
              id
              per_month_fee
              per_year_fee
              default_status
            }
          }
        }
      }
    `,
    getAllAddons: gql`
      query {
        getAllAddons(queryData: {}) {
          id
          name
          description
          per_year_fee
          per_month_fee
        }
      }
    `,
  },
};
</script>
<style scoped lang="scss">
::v-deep .v-btn__content {
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1 0 auto;
  justify-content: inherit;
  line-height: normal;
  position: relative;
  transition: inherit;
  transition-property: opacity;
  padding-right: 30px;
  padding-left: 30px;
}

::v-deep .theme--light.v-card > .v-card__text,
.theme--light.v-card > .v-card__subtitle {
  color: rgba(0, 0, 0, 1);
}

::v-deep .material-icons {
  color: #00bd73;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-top: 0px;
  margin-bottom: -18px;
}

::v-deep .v-text-field.v-text-field--enclosed {
  margin: 0;
  padding: 0;
  background: #f4f8f7;
}
.addon-prices {
  display: flex;
  align-items: center;
  font-size: 12px;
}
.addon-prices::before {
  content: "";
  width: 17px;
  height: 17px;
  display: inline-block;
  background-color: #d9d9d9;
  border-radius: 50%;
  margin-right: 5px;
}
.addon-name {
  font-size: 12px;
  font-weight: 600;
}
.addon-name::before {
  content: "";
  width: 12px;
  height: 12px;
  display: inline-block;
  background-color: #707079;
  border-radius: 50%;
  margin-right: 5px;
}
.mdi-close {
  font-size: 16px;
  background-color: #888888;
  border-radius: 50%;
  color: #ffffff !important;
}
.addons-container {
  background-color: #f9f9f9;
  padding: 16px;
  border-radius: 8px;
  margin-top: 16px;
}
.mdi-close {
  font-size: 16px;
  background-color: transparent;
  border-radius: 50%;
  color: #ffffff !important;
}
.newD {
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #da3d3d;
}

::v-deep .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f4f8f7;
}
.col-6 {
  display: flex;
}
</style>
